import Crud from '../views/User/Crud'
import Reset from '../views/User/Reset'
import Entity from '../views/User/Add'
import View from '../views/User/View'

let routes = {
    path: '/users',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/users/add',
            name: 'NewUser',
            component: Entity,
            meta: {
                perfil_id: ['5', '7'],
                pageTitle: 'Criação de Usuário',
                breadcrumb: [
                    {
                        text: 'Usuários',
                        active: false,
                        to: '/users',
                    },
                    {
                        text: 'Editar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/users/edit/:id?',
            name: 'EditUser',
            component: Entity,
            meta: {
                pageTitle: 'Edição de Usuário',
                perfil_id: ['5', '7'],
                breadcrumb: [
                    {
                        text: 'Usuários',
                        active: false,
                        to: '/users',
                    },
                    {
                        text: 'Editar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/users/view/:id?',
            name: 'ViewUser',
            component: View,
            meta: {
                perfil_id: ['5', '7'],
                pageTitle: 'Visualizar Usuário',
                breadcrumb: [
                    {
                        text: 'Usuários',
                        active: false,
                        to: '/users',
                    },
                    {
                        text: 'Visualizar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/users/reset-password/:id?',
            name: 'ResetPasswordUser',
            component: Reset,
            meta: {
                perfil_id: ['5', '7'],
                pageTitle: 'Resetar senha',
                breadcrumb: [
                    {
                        text: 'Usuários',
                        active: false,
                        to: '/users',
                    },
                    {
                        text: 'Resetar senha',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/users',
            name: 'list-users',
            component: Crud,
            meta: {
                perfil_id: ['5', '7'],
                pageTitle: 'Lista de Usuários',
                breadcrumb: [
                    {
                        text: 'Usuários',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
